import { useEffect, useMemo } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { getKonspektExtensions } from '../konspekt/konspektEditorExtensions';

function scrollToHash() {
  const raw = window.location.hash.replace(/^#/, '');
  if (!raw) return;
  let id = raw;
  try {
    id = decodeURIComponent(raw);
  } catch {
    /* keep raw */
  }
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function KonspektTiptapView({ docJson }) {
  const extensions = useMemo(() => getKonspektExtensions({ editable: false }), []);
  const editor = useEditor({
    extensions,
    content: docJson || { type: 'doc', content: [{ type: 'paragraph' }] },
    editable: false,
  });

  useEffect(() => {
    if (!editor || !docJson) return;
    editor.commands.setContent(docJson);
  }, [editor, docJson]);

  useEffect(() => {
    if (!editor) return undefined;
    const t = window.setTimeout(scrollToHash, 50);
    window.addEventListener('hashchange', scrollToHash);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener('hashchange', scrollToHash);
    };
  }, [editor, docJson]);

  if (!editor) {
    return <div className="konspekt-readonly-loading">Загрузка…</div>;
  }

  function onClick(e) {
    const a = e.target.closest('a.konspekt-link');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (!href.startsWith('#')) return;
    e.preventDefault();
    const id = href.slice(1);
    window.history.replaceState(null, '', href);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return (
    <div className="konspekt-readonly konspekt-tiptap-shell" onClick={onClick}>
      <EditorContent editor={editor} />
    </div>
  );
}
